import React from 'react';
import { StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { FieldDiamond } from './FieldDiamond';
import { coaches } from '../data/coaches';
const chips = ['6 Volumes', '5 Bonuses', '300+ Pages', '37 Ready-to-Run Practices', 'A full season, planned'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it and coach from it'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-navy-deep" data-id="element-111" data-mp="128z14h6wu40r">
      {/* Chalk-diamond cover motif, like the product covers */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-112" data-mp="sbb1pdyd08c9">
        <div className="absolute -right-24 -top-24 h-[380px] w-[380px] rounded-full bg-green/25 blur-3xl" data-id="element-113" data-mp="sddzik5r75rj" />
        <FieldDiamond className="absolute -left-16 top-28 h-[300px] w-[300px] text-ice/[0.06] sm:h-[360px] sm:w-[360px]" data-id="element-114" data-mp="nekkuoeqd8ps" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-5 pt-6 pb-16 sm:pt-10 sm:pb-20" data-id="element-115" data-mp="3825yir8x69lw">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-116" data-mp="3j7zh7oa6s2jb">
          <div data-id="element-117" data-mp="3o7c05xxxspgm">
            <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-118" data-mp="3o7vllomspvze">
              The season-ready system for youth baseball coaches
            </p>
            <h1 className="mt-3 font-display font-bold uppercase text-white text-4xl leading-[.91] tracking-tight sm:text-6xl md:text-7xl" data-id="element-119" data-mp="3e9fs5f0aqamq">
              Your next baseball practice is{' '}
              <span className="text-gold" data-id="element-120" data-mp="30g6jxho33v5s">already planned.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg text-white/75" data-id="element-121" data-mp="35a2hij0frg0f">
              Baseball Practice Ready is a six-volume coaching system: a full
              season of fun, ready-to-run practices &mdash; drills, game-day
              plans and printable sheets. Not a pile of drills to sort through:
              the practice itself, timed and sequenced, ready to run.
            </p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-122" data-mp="2ljz0ijki2xrk">
              {chips.map(chip => <li key={chip} className="rounded-md border border-ice-dark/40 bg-ice-dark/10 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-ice-dark" data-id="element-123" data-mp="s3ck463mvbog">
                  {chip}
                </li>)}
            </ul>
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/kA9rMGNVZjef4jRLAyfBcV/hf_20260917_201332_a3bfb0b8-157d-4b54-a2eb-451848ca04aa.png" alt="Baseball Practice Ready box set: six volumes fanned out above the system shown on desktop, tablet and phone" width={1200} height={886} className="w-full h-auto" data-id="element-124" data-mp="db2f5gbomhns" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-125" data-mp="x37cyf6yybc5">
          <div className="w-full max-w-md" data-id="element-126" data-mp="3lu03r3mln90s">
            <CtaButton data-id="element-127" data-mp="3lquhrx99on9a">Get Baseball Practice Ready</CtaButton>
          </div>
          <div className="mt-5 flex flex-col items-center gap-2.5 sm:flex-row sm:gap-4" data-id="element-128" data-mp="3hpsg79rvnz45">
            <ul className="flex -space-x-2.5" data-id="element-129" data-mp="1xama741tsf59">
              {coaches.map(coach => <li key={coach.name} data-id="element-130" data-mp="21bxwp0pekk98">
                  <img src={coach.avatar} alt={coach.name} width={40} height={40} loading="lazy" className="h-10 w-10 rounded-full border-2 border-navy-deep object-cover" data-id="element-131" data-mp="218tkph5p4k80" />
                </li>)}
            </ul>
            <div className="text-center sm:text-left" data-id="element-132" data-mp="2kxkk1ivfwou7">
              <span className="flex justify-center gap-0.5 sm:justify-start" aria-label="Rated 4.9 out of 5" data-id="element-133" data-mp="2p0qnkir641wz">
                {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-134" data-mp="umpqa2b9nmz0" />)}
              </span>
              <p className="mt-1 text-xs text-white/65" data-id="element-135" data-mp="4akyn39aysi3">
                <span className="font-bold text-white" data-id="element-136" data-mp="4d7858fr7i2y">4.9/5</span> from 1,200+
                coaches running this system
              </p>
            </div>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-137" data-mp="e91wmk6ns7dn">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-138" data-mp="3hqaayu26gp3m">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-139" data-mp="3hqjzed7kqo77" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}